import BrandingSegmentationDirective from './BrandingSegmentationDirective';
import BrandingData from 'gw-portals-branding-js/BrandingData';

export default angular.module('edge.platform.segmentation.branding', [])
    .value('brandingData', BrandingData.BRANDING)
    .directive('gwBrandingSegmentation', BrandingSegmentationDirective);